import axios from 'axios'
import { handleResponse, handleError } from '../helpers/api'
import store from '../store'

const apiClient = axios.create({
  baseURL: `${window.config.VUE_APP_API_BASE_URL}/User`,
  withCredentials: true
})

const apiCmsClient = axios.create({
  baseURL: `${window.config.VUE_APP_CMS_API_BASE_URL}/content`
})

function getHeader() {
  return {
    headers: { Authorization: 'bearer ' + store.getters.jwtToken }
  }
}

export const userService = {
  register,
  logout,
  login,
  getUsers,
  createUser,
  deleteUser,
  updateUser
}

async function register(payload) {
  payload.firsName = ''
  payload.lastName = ''
  return apiClient
    .post('/register', payload)
    .then(handleResponse)
    .catch(e => {
      return handleRegistrationError(e)
    })
}
async function getUsers() {
  return apiClient
    .get('', getHeader())
    .then(handleResponse)
    .catch(e => {
      return handleError(e)
    })
}

async function createUser(payload) {
  return apiClient
    .post('/create', payload, getHeader())
    .then(handleResponse)
    .catch(e => {
      return handleError(e)
    })
}

async function updateUser(payload) {
  return apiClient
    .put('/id?id=' + payload.id, payload, getHeader())
    .then(handleResponse)
    .catch(e => {
      return handleError(e)
    })
}

async function deleteUser(payload) {
  return apiClient
    .delete('/id?id=' + payload, getHeader())
    .then(handleResponse)
    .catch(e => {
      return handleError(e)
    })
}

async function login(payload) {
  return apiClient
    .post('/login', payload)
    .then(handleResponse)
    .catch(handleError)
}

function logout() {
  return apiClient.post('/logout')
}

// /content/registrations?Language=DE

async function handleRegistrationError(inputError) {
  if (inputError instanceof Error && inputError.message === 'Network Error') {
    inputError.fromCms = false
    inputError.response = { status: '503' }
    return Promise.reject(inputError)
  }
  const statuscode = inputError.response.status
  return apiCmsClient
    .get('/registrationerrors', {
      params: {
        statuscode: statuscode
      }
    })
    .then(response => {
      let errorReturned = response.data[0]
      errorReturned.fromCms = true
      return Promise.reject(errorReturned)
    })
    .catch(() => {
      inputError.fromCms = false
      return Promise.reject(inputError)
    })
}
